import { fetchURLByClassifiedId, getCookie, getCustomerType, getPropertyType, getTransactionType, getUrlWithParams, readEnvFile, retrieveURLUponSelection, } from '../../utils';
const { CAF2010Url } = readEnvFile();
export const getRedirectUrl = async () => {
    if (!getCookie('oauth.access.token')) {
        return { url: getUrlWithParams(CAF2010Url) };
    }
    try {
        const customerType = await getCustomerType();
        if (customerType?.toLowerCase() === 'private') {
            return { isPrivateCustomer: true };
        }
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.toString() === '')
            return { url: null };
        const classifiedId = urlParams.get('gok');
        const estateType = urlParams.get('esr');
        const transactionType = urlParams.get('etype');
        if (classifiedId) {
            const url = await fetchURLByClassifiedId(classifiedId);
            return { url: getUrlWithParams(url) };
        }
        const mappedTransactionType = transactionType && getTransactionType(transactionType);
        const mappedPropertyType = estateType && getPropertyType(estateType);
        if (mappedTransactionType && mappedPropertyType) {
            const url = await retrieveURLUponSelection(mappedPropertyType, mappedTransactionType);
            return { url: getUrlWithParams(url) };
        }
        return { searchParams: urlParams.toString() };
    }
    catch (error) {
        console.error(error);
    }
    return { url: getUrlWithParams(CAF2010Url) };
};
